import ReactGA from "react-ga4";
import Style from "./MentorsCarousel.module.css";

function MentorsCarousel(props) {
    const wekLeaders = props.mentors["week_leaders"]
    const monthLeaders = props.mentors["month_leaders"]
    const yearLeaders = props.mentors["year_leaders"]

    const mentorCard = (id, name, photoLink, description, instagram, longBio) => {
        return (
            <div key={id} className={Style.card}>
                <img className={Style.image} src={photoLink} alt={""}></img>
                <h5 className={Style.title}>{name}</h5>
                <div className={Style.text}>{description}</div>
                <div className={Style.button}>
                    <a onClick={() => sendEvent(id)} href={instagram} target="_blank"><b>Мій профіль</b></a>
                </div>
                <div style={{paddingTop: "50px", fontSize:"0.5em"}}>
                    {longBio}
                </div>

            </div>
        )
    }

    function sendEvent(id) {
        ReactGA.event( {
            action: "mentor instagram click",
            category:"external navigate",
            label: "Start page: mentor section",
            value: id
        })
    }

    return (
        <div style={{display: "flex", flexDirection: "row", gap: "6px"}}>
            {wekLeaders.map((leader) => {
                return mentorCard(leader.id, leader.nickname, leader.photo_url, leader.short_bio, leader.social_url, leader.long_bio)
                }
            )}
            {monthLeaders.map((leader) => {
                    return mentorCard(leader.id, leader.nickname, leader.photo_url, leader.short_bio, leader.social_url, leader.long_bio)
                }
            )}
            {yearLeaders.map((leader) => {
                    return mentorCard(leader.id, leader.nickname, leader.photo_url, leader.short_bio, leader.social_url, leader.long_bio)
                }
            )}
        </div>

    )
}

export default MentorsCarousel